import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Linkedin } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const teamMembers = [{
  name: 'Tatwagyani Sumanand Sagar',
  role: 'Founder & Spiritual Director',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1887&auto=format&fit=crop',
  bio: 'With over 40 years of dedicated practice and teaching, Tatwagyani Sumanand Sagar founded Supradhyan in 1985 to share authentic spiritual wisdom with the modern world. His compassionate guidance has transformed thousands of lives.',
  email: 'satguru@supradhyan.org'
}, {
  name: 'Dr. Anjali Mehta',
  role: 'Executive Director',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1888&auto=format&fit=crop',
  bio: 'Dr. Mehta holds a PhD in Psychology and has been practicing meditation for 20 years. She oversees all center operations, ensuring our programs maintain the highest standards of authenticity and care.',
  email: 'anjali@supradhyan.org'
}, {
  name: 'Ravi Sharma',
  role: 'Director of Programs',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=2070&auto=format&fit=crop',
  bio: 'Ravi designs and coordinates all retreat programs, bringing 15 years of experience in spiritual education. His attention to detail creates transformative experiences for every participant.',
  email: 'ravi@supradhyan.org'
}, {
  name: 'Maya Patel',
  role: 'Senior Meditation Teacher',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=1961&auto=format&fit=crop',
  bio: 'Maya has been teaching meditation for 18 years, specializing in mindfulness and chakra practices. Her gentle yet powerful teaching style helps students access deep states of awareness.',
  email: 'maya@supradhyan.org'
}, {
  name: 'David Chen',
  role: 'Yoga & Pranayama Instructor',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=1887&auto=format&fit=crop',
  bio: 'Certified in multiple yoga traditions, David brings precision and depth to physical practice. He specializes in advanced pranayama techniques and their integration with meditation.',
  email: 'david@supradhyan.org'
}, {
  name: 'Priya Krishnan',
  role: 'Community & Outreach Director',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=2070&auto=format&fit=crop',
  bio: 'Priya manages our scholarship programs and community initiatives, ensuring meditation remains accessible to all. Her passion for service creates meaningful connections across diverse communities.',
  email: 'priya@supradhyan.org'
}, {
  name: 'James Wilson',
  role: 'Facilities & Operations Manager',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1887&auto=format&fit=crop',
  bio: 'James ensures our sacred spaces are maintained with care and mindfulness. With a background in sustainable architecture, he oversees our eco-friendly campus operations.',
  email: 'james@supradhyan.org'
}, {
  name: 'Sarah Thompson',
  role: 'Volunteer Coordinator',
  image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?q=80&w=2071&auto=format&fit=crop',
  bio: 'Sarah guides our karma yoga program, supporting volunteers in their service journey. Her warmth and organizational skills create a nurturing environment for selfless action.',
  email: 'sarah@supradhyan.org'
}];
export function TeamPage() {
  return <div className="min-h-screen bg-[#FFFBF5]" data-id="element-962">
      <Header data-id="element-963" />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#8B9D83]/10 via-[#FAF7F2] to-[#B8A4C9]/10" data-id="element-964">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-965">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center max-w-3xl mx-auto" data-id="element-966">
            <h1 className="font-serif text-5xl md:text-6xl text-[#2C3E50] mb-6 leading-tight" data-id="element-967">
              Our Management Team
            </h1>
            <p className="text-xl text-[#5D6D7E] leading-relaxed" data-id="element-968">
              Dedicated individuals committed to preserving authentic spiritual
              teachings and creating transformative experiences for all who seek
              inner peace.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Team Grid */}
      <section className="py-20 bg-white" data-id="element-969">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-970">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12" data-id="element-971">
            {teamMembers.map((member, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="group" data-id="element-972">
                {/* Photo */}
                <div className="relative aspect-[4/5] rounded-2xl overflow-hidden mb-6 shadow-lg" data-id="element-973">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-974" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-975" />

                  {/* Social Links - Appear on Hover */}
                  <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-976">
                    <a href={`mailto:${member.email}`} className="w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center hover:bg-[#8B9D83] hover:text-white transition-colors" data-id="element-977">
                      <Mail className="w-5 h-5" data-id="element-978" />
                    </a>
                    <a href="#" className="w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center hover:bg-[#8B9D83] hover:text-white transition-colors" data-id="element-979">
                      <Linkedin className="w-5 h-5" data-id="element-980" />
                    </a>
                  </div>
                </div>

                {/* Info */}
                <div data-id="element-981">
                  <h3 className="font-serif text-2xl font-bold text-[#2C3E50] mb-2 group-hover:text-[#8B9D83] transition-colors" data-id="element-982">
                    {member.name}
                  </h3>
                  <div className="text-[#D4AF37] font-semibold mb-4" data-id="element-983">
                    {member.role}
                  </div>
                  <p className="text-[#5D6D7E] leading-relaxed" data-id="element-984">{member.bio}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Join Our Team */}
      <section className="py-20 bg-[#FAF7F2]" data-id="element-985">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-986">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-987">
            <h2 className="font-serif text-4xl text-[#2C3E50] mb-6" data-id="element-988">
              Join Our Team
            </h2>
            <p className="text-lg text-[#5D6D7E] mb-10" data-id="element-989">
              We're always looking for dedicated individuals who share our
              vision of spreading peace and wisdom. Explore opportunities to
              serve through our volunteer program or career openings.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-990">
              <button className="bg-[#8B9D83] hover:bg-[#7A8C72] text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg" data-id="element-991">
                View Career Opportunities
              </button>
              <button className="border-2 border-[#8B9D83] text-[#8B9D83] hover:bg-[#8B9D83] hover:text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300" data-id="element-992">
                Volunteer with Us
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-993" />
    </div>;
}